import ProfileErrorBanner from "./ProfileErrorBanner";
import PurchaseStateErrorBanner from "./PurchaseStateErrorBanner";

export function RecoveryBanners() {
  return (
    <div className="w-full shrink-0">
      <PurchaseStateErrorBanner />
      <ProfileErrorBanner />
    </div>
  );
}

export default RecoveryBanners;
